// Data for /famous-families — India's great historic & contemporary families.
// Portrait images sourced from Wikimedia Commons (public domain / freely licensed).
// Icons resolved in the component via lucide-react.

export const FAMOUS_FAMILIES = [
  {
    id: "nehru-gandhi",
    number: "01",
    name: "The Nehru–Gandhi Family",
    icon: "Landmark",
    type: "Political",
    origin: "Prayagraj (Allahabad), Uttar Pradesh",
    community: "Kashmiri Pandit",
    known_for: "Politics and public service",
    lineage: [
      "Motilal Nehru",
      "Jawaharlal Nehru",
      "Indira Gandhi",
      "Rajiv Gandhi",
      "Rahul Gandhi & Priyanka Gandhi Vadra",
    ],
    patriarchs: ["Motilal Nehru", "Jawaharlal Nehru"],
    matriarchs: ["Kamala Nehru", "Indira Gandhi", "Sonia Gandhi"],
    legacy:
      "Few families have shaped independent India's political landscape as profoundly. Beginning with Motilal Nehru — a prominent lawyer and freedom fighter — the family produced India's first Prime Minister, Jawaharlal Nehru, and later Indira Gandhi and Rajiv Gandhi. Their influence spans constitutional development, foreign policy, education, science and democratic institutions.",
    portrait:
      "https://images.unsplash.com/photo-1587474260584-136574528ed5?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
    accent: "#8B261D",
    wiki: "https://en.wikipedia.org/wiki/Nehru%E2%80%93Gandhi_family",
    video: "https://www.youtube.com/results?search_query=nehru+gandhi+family+documentary",
  },
  {
    id: "tata",
    number: "02",
    name: "The Tata Family",
    icon: "Factory",
    type: "Business",
    origin: "Navsari, Gujarat",
    community: "Parsi Zoroastrian",
    known_for: "Industry, philanthropy, education",
    lineage: [
      "Jamsetji Tata",
      "Sir Dorabji Tata",
      "J. R. D. Tata",
      "Ratan Tata",
    ],
    patriarchs: ["Jamsetji Tata", "J. R. D. Tata", "Ratan Tata"],
    matriarchs: [],
    legacy:
      "The Tatas helped establish modern Indian industry — steel, hospitality, aviation, automobiles, software, healthcare and education. Their philanthropic trusts have funded universities, hospitals, scientific research and social development for more than a century.",
    portrait:
      "https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
    accent: "#2D4A3E",
    wiki: "https://en.wikipedia.org/wiki/Tata_family",
    video: "https://www.youtube.com/results?search_query=jamsetji+tata+documentary",
  },
  {
    id: "birla",
    number: "03",
    name: "The Birla Family",
    icon: "Building2",
    type: "Business",
    origin: "Pilani, Rajasthan",
    community: "Marwari",
    known_for: "Cement, metals, financial services, telecom, textiles, education",
    lineage: [
      "Baldeodas Birla",
      "Ghanshyam Das Birla",
      "Basant Kumar Birla",
      "Aditya Vikram Birla",
      "Kumar Mangalam Birla",
    ],
    patriarchs: ["Ghanshyam Das Birla", "Basant Kumar Birla"],
    matriarchs: [],
    legacy:
      "From a merchant family in Rajasthan, the Birlas became one of India's largest industrial dynasties. Their contributions extend to education, philanthropy, manufacturing and the independence movement — G.D. Birla was a close confidant of Mahatma Gandhi.",
    portrait:
      "https://images.unsplash.com/photo-1477587458883-47145ed94245?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
    accent: "#E86A33",
    wiki: "https://en.wikipedia.org/wiki/Birla_family",
    video: "https://www.youtube.com/results?search_query=birla+family+documentary",
  },
  {
    id: "wadiyar",
    number: "04",
    name: "The Wadiyar Dynasty of Mysore",
    icon: "Crown",
    type: "Royal",
    origin: "Mysuru, Karnataka",
    community: "Arasu (Wodeyar) royal house",
    known_for: "Progressive princely state — education, engineering, arts",
    lineage: [
      "Yaduraya Wodeyar",
      "Raja Wadiyar I",
      "Krishnaraja Wadiyar III",
      "Nalwadi Krishnaraja Wadiyar IV",
      "Yaduveer Krishnadatta Chamaraja Wadiyar",
    ],
    patriarchs: ["Raja Wadiyar I", "Krishnaraja Wadiyar III", "Nalwadi Krishnaraja Wadiyar IV"],
    matriarchs: [],
    legacy:
      "Founded in the late 14th century, the Wadiyars transformed Mysore into one of India's most progressive princely states, investing heavily in education, engineering, public infrastructure, hydroelectric power and the arts — including the founding institutions that would become IISc.",
    portrait:
      "https://images.unsplash.com/photo-1524492412937-b28074a5d7da?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
    accent: "#F2A93B",
    wiki: "https://en.wikipedia.org/wiki/Wadiyar_dynasty",
    video: "https://www.youtube.com/results?search_query=wadiyar+dynasty+mysore+documentary",
  },
  {
    id: "scindia",
    number: "05",
    name: "The Scindia Family",
    icon: "Shield",
    type: "Royal / Political",
    origin: "Gwalior, Madhya Pradesh",
    community: "Maratha (Shinde clan)",
    known_for: "Maratha empire military leadership, modern Indian politics",
    lineage: [
      "Ranoji Scindia",
      "Mahadji Scindia",
      "Jivajirao Scindia",
      "Madhavrao Scindia",
      "Jyotiraditya Scindia",
    ],
    patriarchs: ["Mahadji Scindia", "Madhavrao Scindia", "Jyotiraditya Scindia"],
    matriarchs: ["Vijaya Raje Scindia"],
    legacy:
      "The Scindias rose under the Maratha Confederacy and, at their peak, held sway from Gwalior across large parts of northern and central India. In the modern era they have played prominent roles in politics, education and public administration.",
    portrait:
      "https://images.unsplash.com/photo-1626621341517-bbf3d9990a23?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
    accent: "#8B261D",
    wiki: "https://en.wikipedia.org/wiki/Scindia",
    video: "https://www.youtube.com/results?search_query=scindia+family+documentary",
  },
  {
    id: "holkar",
    number: "06",
    name: "The Holkar Dynasty",
    icon: "Sparkles",
    type: "Royal",
    origin: "Indore, Madhya Pradesh",
    community: "Maratha (Holkar clan)",
    known_for: "Just governance, temple rebuilding, women's leadership",
    lineage: [
      "Malhar Rao Holkar",
      "Ahilyabai Holkar",
      "Tukojirao Holkar II",
      "Yashwant Rao Holkar II",
    ],
    patriarchs: ["Malhar Rao Holkar"],
    matriarchs: ["Ahilyabai Holkar"],
    legacy:
      "Ahilyabai Holkar is remembered as one of India's most admired rulers — she rebuilt temples, roads, pilgrim centers and charitable institutions across India while promoting justice and good governance from her seat at Maheshwar.",
    portrait:
      "https://images.unsplash.com/photo-1595658658481-d53d3f999875?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
    accent: "#2D4A3E",
    wiki: "https://en.wikipedia.org/wiki/Holkar_dynasty",
    video: "https://www.youtube.com/results?search_query=ahilyabai+holkar+documentary",
  },
  {
    id: "gaekwad",
    number: "07",
    name: "The Gaekwad Family",
    icon: "Castle",
    type: "Royal",
    origin: "Vadodara, Gujarat",
    community: "Maratha royal house of Baroda",
    known_for: "Social reform, universal education, museums, libraries",
    lineage: [
      "Pilaji Rao Gaekwad",
      "Sayajirao Gaekwad III",
      "Pratapsinhrao Gaekwad",
      "Ranjitsinh Pratapsinh Gaekwad",
      "Samarjitsinh Gaekwad",
    ],
    patriarchs: ["Sayajirao Gaekwad III"],
    matriarchs: [],
    legacy:
      "The Gaekwads modernised Baroda through universal education, libraries, public parks, museums and social reforms — many later adopted across India. Maharaja Sayajirao III founded what would become Maharaja Sayajirao University of Baroda.",
    portrait:
      "https://images.pexels.com/photos/30320070/pexels-photo-30320070.jpeg?auto=compress&cs=tinysrgb&w=900",
    accent: "#E86A33",
    wiki: "https://en.wikipedia.org/wiki/Gaekwad_dynasty",
    video: "https://www.youtube.com/results?search_query=sayajirao+gaekwad+documentary",
  },
  {
    id: "tagore",
    number: "08",
    name: "The Tagore Family",
    icon: "BookOpen",
    type: "Cultural",
    origin: "Jorasanko, Kolkata, West Bengal",
    community: "Pirali Brahmin",
    known_for: "Literature, art, music, education",
    lineage: [
      "Dwarkanath Tagore",
      "Debendranath Tagore",
      "Rabindranath Tagore",
      "Abanindranath Tagore",
    ],
    patriarchs: ["Dwarkanath Tagore", "Debendranath Tagore"],
    matriarchs: [],
    legacy:
      "The Tagores became synonymous with the Bengal Renaissance, producing influential poets, artists, musicians, educators and reformers whose work reshaped Indian literature and culture. Rabindranath Tagore was the first non-European to win the Nobel Prize in Literature (1913).",
    portrait:
      "https://images.unsplash.com/photo-1558431382-27e303142255?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
    accent: "#2D4A3E",
    wiki: "https://en.wikipedia.org/wiki/Tagore_family",
    video: "https://www.youtube.com/results?search_query=rabindranath+tagore+documentary",
  },
  {
    id: "godrej",
    number: "09",
    name: "The Godrej Family",
    icon: "Home",
    type: "Business",
    origin: "Mumbai, Maharashtra",
    community: "Parsi Zoroastrian",
    known_for: "Consumer goods, real estate, agriculture, appliances",
    lineage: [
      "Ardeshir Godrej",
      "Pirojsha Burjorji Godrej",
      "Naval Godrej",
      "Adi Godrej",
      "Nadir Godrej",
      "Jamshyd Godrej",
    ],
    patriarchs: ["Ardeshir Godrej", "Pirojsha Godrej"],
    matriarchs: [],
    legacy:
      "The Godrej family established one of India's most trusted business groups, known for engineering excellence — from the first locks made in India to environmental stewardship of the vast Godrej mangrove in Mumbai's Vikhroli.",
    portrait:
      "https://images.unsplash.com/photo-1732303105237-f5b5f7a2390e?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
    accent: "#F2A93B",
    wiki: "https://en.wikipedia.org/wiki/Godrej_family",
    video: "https://www.youtube.com/results?search_query=godrej+family+history",
  },
  {
    id: "bajaj",
    number: "10",
    name: "The Bajaj Family",
    icon: "Zap",
    type: "Business",
    origin: "Rajasthan → Wardha, Maharashtra",
    community: "Marwari",
    known_for: "Automobiles, financial services, rural philanthropy",
    lineage: [
      "Jamnalal Bajaj",
      "Kamalnayan Bajaj",
      "Rahul Bajaj",
      "Rajiv Bajaj",
      "Sanjiv Bajaj",
      "Niraj Bajaj",
    ],
    patriarchs: ["Jamnalal Bajaj", "Rahul Bajaj"],
    matriarchs: ["Jankidevi Bajaj"],
    legacy:
      "Closely associated with Mahatma Gandhi — who called Jamnalal his fifth son — the Bajaj family built a diversified industrial group while supporting education, rural development and philanthropy from Wardha to the world.",
    portrait:
      "https://images.unsplash.com/photo-1643474003587-8bbf4bbc01d9?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
    accent: "#8B261D",
    wiki: "https://en.wikipedia.org/wiki/Bajaj_Group",
    video: "https://www.youtube.com/results?search_query=jamnalal+bajaj+documentary",
  },
];

export const HISTORIC_ROYAL_HOUSES = [
  { name: "Sisodia Dynasty", region: "Mewar, Rajasthan", wiki: "https://en.wikipedia.org/wiki/Sisodia" },
  { name: "Rathore Dynasty", region: "Marwar, Rajasthan", wiki: "https://en.wikipedia.org/wiki/Rathore" },
  { name: "Kachwaha Dynasty", region: "Jaipur, Rajasthan", wiki: "https://en.wikipedia.org/wiki/Kachhwaha" },
  { name: "Travancore Royal Family", region: "Kerala", wiki: "https://en.wikipedia.org/wiki/Travancore_royal_family" },
  { name: "Cochin Royal Family", region: "Kerala", wiki: "https://en.wikipedia.org/wiki/Cochin_royal_family" },
  { name: "Bhosale Dynasty", region: "Nagpur, Maharashtra", wiki: "https://en.wikipedia.org/wiki/Bhonsle" },
  { name: "Bhonsle / Maratha Lineage of Chhatrapati Shivaji", region: "Satara & Kolhapur", wiki: "https://en.wikipedia.org/wiki/Bhonsle" },
  { name: "Ahom Royal Family", region: "Assam", wiki: "https://en.wikipedia.org/wiki/Ahom_dynasty" },
  { name: "Namgyal Dynasty", region: "Ladakh", wiki: "https://en.wikipedia.org/wiki/Namgyal_dynasty" },
  { name: "Chogyal Dynasty", region: "Former Kingdom of Sikkim", wiki: "https://en.wikipedia.org/wiki/Chogyal" },
];

export const PROFILE_FIELDS = [
  { field: "Family Name", desc: "Official family or dynasty name" },
  { field: "Family Type", desc: "Royal, Political, Business, Cultural, Religious, Community" },
  { field: "Origin", desc: "Village, town, district, state, country" },
  { field: "Community / Lineage", desc: "Clan, dynasty, community or traditional lineage (where historically documented)" },
  { field: "Founder / Ancestor", desc: "Earliest known notable ancestor" },
  { field: "Patriarchs", desc: "Key male figures across generations" },
  { field: "Matriarchs", desc: "Key female figures across generations" },
  { field: "Family Tree", desc: "Interactive genealogical chart" },
  { field: "Timeline", desc: "Major events by generation" },
  { field: "Heritage Sites", desc: "Palaces, homes, temples, estates or businesses associated with the family" },
  { field: "Notable Members", desc: "Biographies of prominent descendants" },
  { field: "Contributions", desc: "Politics, arts, science, business, education, philanthropy, public service" },
  { field: "Photo Gallery", desc: "Historic and contemporary images" },
  { field: "Documents", desc: "Letters, records, certificates, memoirs, archival material" },
  { field: "Sources", desc: "Books, archives, academic research, government records and reputable historical references" },
];
